module.exports = __webpack_public_path__ + "static/media/berkeley-skyline-finish@3x.02674e9a.png";